import React from 'react';
import { TFunction } from 'react-i18next';
import {
  Text,
  Link,
  CodeSnippet,
  Stack,
  Trans,
  OrderedList,
} from '@piwikpro/ui-components';
import { ProductAnalytics } from '@piwikpro/product-analytics';
import { App } from '../../../model';

const PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES = {
  MANUAL_COOKIEBOT: '@platform/command/appInstallation/cookiebot',
};

interface CookiebotInstallProps {
  app: App
  t: TFunction
  installationCodeFailed: boolean
  productAnalytics: ProductAnalytics
  snippet: string
  handleCopyToClipboard: (result: boolean, productAnalyticsActionType: string) => void
}

const CookiebotInstall: React.FC<CookiebotInstallProps> = ({
  app,
  t,
  installationCodeFailed,
  productAnalytics,
  snippet,
  handleCopyToClipboard,
}) => {
  const modifiedSnippet = snippet && !installationCodeFailed
    ? snippet.replace('<script', '<script data-cookieconsent="ignore"')
    : undefined;

  return (
    <Stack vertical>
      <Stack.Item previousSpacing="none">
        <OrderedList>
          <Stack vertical spacing="narrow">
            <Stack.Item previousSpacing="wide">
              <OrderedList.Item>
                <Text as="p">
                  {t('apps.details.installation.cookiebot.instruction.line1-part1')}
                  <b> &lt;body&gt; </b>
                  {t('apps.details.installation.cookiebot.instruction.line1-part2')}
                </Text>
              </OrderedList.Item>
            </Stack.Item>
            <Stack.Item fill>
              <CodeSnippet
                error={installationCodeFailed}
                code={modifiedSnippet}
                onCopy={result => handleCopyToClipboard(
                  result,
                  PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES.MANUAL_COOKIEBOT,
                )}
                mode="no-highlight"
              />
            </Stack.Item>
            <Stack.Item>
              <OrderedList.Item>
                <Text as="p">
                  <Trans
                    t={t}
                    i18nKey="apps.details.installation.cookiebot.instruction.line2.part1"
                    components={[
                      <Link
                        href="https://help.piwik.pro/support/integrations/cookiebot-integration/"
                      >
                        installation guide
                      </Link>,
                    ]}
                    tOptions={{ interpolation: { escapeValue: false } }}
                  />
                </Text>
              </OrderedList.Item>
            </Stack.Item>
            <Stack.Item>
              <OrderedList.Item>
                {t('apps.details.installation.cookiebot.instruction.line3.part1')}
                <Link
                  onClick={() => {
                    productAnalytics.push({ type: `${PRODUCT_ANALYTICS_INSTAL_METHOD_ACTION_TYPES.MANUAL_COOKIEBOT}/tracker-debugger` });
                  }}
                  href={`/analytics/#/${app.id}/settings/debugger/`}
                >
                  {t('apps.details.installation.links.trackerDebugger')}
                </Link>
                {t('apps.details.installation.cookiebot.instruction.line3.part2')}
              </OrderedList.Item>
            </Stack.Item>
            <Stack.Item previousSpacing="wide" />
          </Stack>
        </OrderedList>
      </Stack.Item>
      <Stack.Item previousSpacing="none">
        <Text as="p">
          <Trans
            i18nKey="apps.details.installation.cookiebot.instruction.line4.part1"
            components={[
              <Link href="http://community.piwik.pro/">
                community
              </Link>,
            ]}
          />
        </Text>
      </Stack.Item>
    </Stack>
  );
};

export default CookiebotInstall;
